import { BooleanField, StringField } from 'vuex-orm-decorators'
import AbstractModel from '@/dataAccess/models/AbstractModel'

export default class AbstractPerson extends AbstractModel {
  @StringField()
  public fullName: string
  @BooleanField(null)
  public isArchived: boolean

  static getNotArchived() {
    return this.query()
      .where('isArchived', false)
      .get()
  }
}
